import { CalendarOutlined, LineOutlined, PlusOutlined, TagOutlined } from '@ant-design/icons'
import { Radio, Switch, Tabs, TabsProps } from 'antd'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import * as selectOptionsApi from '../../../../../api/selectOptions/selectOptionsApi'
import SvgIconWithMask from '../../../../../components/SvgIconWithMask'
import { URL_NETWORK, URL_TEMPLATE_IMG } from '../../../../../env'
import '../../CampaignSendsNotifications.scss'

import '../../../../../components/ExportImgFigma'

import { ColDef } from 'ag-grid-community'
import { getInfoCampaignCosts, ICampaignCosts } from '../../../../../api/campaign/campaignApi'
import { user_double, viettel, ZNS } from '../../../../../components/ExportImgFigma'
import useDebounce from '../../../../../hook/useDebounce'
import useLoading from '../../../../../hook/useLoading'
import useToast from '../../../../../hook/useToast'
import { formatNumber } from '../../../../../services/mixin'
import { fommatSelectOption, formatDateToDMY, formatDateToDMYGroup, formatPrice, getTitleSelectOption } from '../../../../../until'
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import { CONDITIONGROUP } from '../../../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic'
import { ISelectedCustomer } from '../../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import '../../CampaignSendsNotifications.scss'
import { CampaignStep, IDataFilterGroupList, InfoCampaignTmp, IVConditionFilterCampaim, useCustomerGroupContext } from '../../Create'
import { filterInfoOperator } from '../../Create/Modal/ModalConditionCampaign'
import { channels, IChannelListTmp, IChannelListTmpV9, SendStrategy, SendTimeType } from '../../Create/Component/InfoCreate'
import { getlistMessagingProviderConfig } from '../../../../../api/generalConfiguration/generalConfigurationApi'
import dayjs from 'dayjs'
import { Location, useLocation } from 'react-router-dom'
import TableCustomerDetail from './TableCustomerDetail'
import TableLogDetail from './TableLogDetail'
import ItemConditionDisplay from '../../../../Customers/CustomerGroup/Component/ViewGroup/components/ItemConditionDisplay'
import { getListConfigTemplate } from '../../../../../api/notificationTemplate/notificationTemplateApi'
import { useSelector } from 'react-redux'
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice'
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice'
import { dataSendEvent } from '../../../../../services/data'


interface props {
  loading: boolean
  location: Location<any>
  step: CampaignStep
  memoizedColumnDefs: ColDef<any, any>[]
  infoCampaign?: InfoCampaignTmp
  sqlTotal?: string
  listMatchedCustomers: any[]
  dataFilterMatchedCustomers: IDataFilterGroupList
  paginationMatchedCustomers: IPagination
  selectedIdCustomer: ISelectedCustomer[]
  infoOperator: IVConditionFilterCampaim

  setInfoCampaign?: (value?: InfoCampaignTmp) => void
  setDataFilterMatchedCustomers: (value: IDataFilterGroupList) => void
  onPaginationMatchedCustomers: (page: number, pageSize: number) => void

}

const Detail: React.FC<props> = ({
  loading,
  location,
  step, memoizedColumnDefs, infoCampaign,
  sqlTotal,
  dataFilterMatchedCustomers, paginationMatchedCustomers,
  listMatchedCustomers,
  selectedIdCustomer,
  infoOperator,
  setDataFilterMatchedCustomers, onPaginationMatchedCustomers,
  setInfoCampaign
}) => {

  // const location = useLocation()
  const { id } = location.state
  const pushToast = useToast()
  const pushLoading = useLoading()
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const [isMore, setMore] = useState<boolean>(true)
  const channelDataFetchedRef = useRef(false)

  const [infoCampaignCosts, setInfoCampaignCosts] = useState<ICampaignCosts>();

  const { sLTarget } = useCustomerGroupContext()

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>,
      children:
        <TableCustomerDetail
          loading={loading}
          memoizedColumnDefs={memoizedColumnDefs}

          listMatchedCustomers={listMatchedCustomers}
          dataFilterMatchedCustomers={dataFilterMatchedCustomers}


          paginationMatchedCustomers={paginationMatchedCustomers}

          setDataFilterMatchedCustomers={setDataFilterMatchedCustomers}

          onPaginationMatchedCustomers={onPaginationMatchedCustomers}
          selectedIdCustomer={selectedIdCustomer}

        />,
    },
    {
      key: '2',
      label: <span className='custom-page-css text-base font-regular'>Lịch sử</span>,
      children:
        <TableLogDetail
          id={id}
          selectedIdCustomer={selectedIdCustomer}
        />,
    },
  ];


  const dataTarget = useMemo(() => {
    const targetIds = infoCampaign?.targetId
    if (!targetIds || !sLTarget) return []

    const ids = Array.isArray(targetIds) ? targetIds : [targetIds]

    return sLTarget.filter(item => ids.includes(item.id))
  }, [infoCampaign?.targetId, sLTarget])

  const dataCondition = useMemo(() => {
    const filtered = filterInfoOperator(infoOperator);
    if (
      filtered.typeCondition !== CONDITIONGROUP.ALL &&
      filtered.conditions.length === 0
    ) {
      return null;
    }
    return filtered;
  }, [infoOperator]);




  const gInfoCampaignCosts = useDebounce(async () => {
    pushLoading(true)

    const customerId = selectedIdCustomer.length
      ? selectedIdCustomer.map((item: ISelectedCustomer) => Number(item.customerId))
      : undefined;
    const groupCustomerId = infoCampaign?.groupCustomerId?.map(item => Number(item.id))

    const channelListTmp = infoCampaign?.channelList?.map(item => ({
      channelId: item.channelId,
      brandId: item.brandId ?? 0,
      notificationTemplateId: item.notificationTemplateId ?? 0,
    }))

    const result = await getInfoCampaignCosts(
      customerId, groupCustomerId, channelListTmp, sqlTotal,
      undefined, infoCampaign?.voucherId
    )
    if (result?.status) {
      setInfoCampaignCosts(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 2000)

  const gDatachannelList = async (data: IChannelListTmpV9[]) => {


    if (!data.length) return;

    const brandCache = new Map<number, selectOptionsApi.ISelectOption[]>();
    const templateCache = new Map<number, selectOptionsApi.ISelectOption[]>();

    const nextData = await Promise.all(
      data.map(async (item) => {
        const { channelId, brandId, notificationTemplateId } = item;

        if (!channelId) return item;

        try {
          // 👉 tạo promise độc lập
          const brandPromise = (async () => {
            const res = await getListConfigTemplate(
              permittedCategoryCarIds, channelId,
              unitTemp
            );

            const brands = res?.status
              ? fommatSelectOption(res.data.brandNames)
              : [];

            brandCache.set(channelId, brands);
            return brands;
          })();

          const templatePromise = (async () => {
            const res = await getListConfigTemplate(
              permittedCategoryCarIds, channelId,
              unitTemp, brandId

            );

            const templates = res?.status
              ? fommatSelectOption(res.data.templates)
              : [];

            templateCache.set(brandId, templates);
            return templates;
          })();

          // 👉 chạy song song thật sự
          const [brands, templates] = await Promise.all([
            brandPromise,
            templatePromise
          ]);

          return {
            ...item,
            ...(brands ? { brands } : {}),
            ...(templates ? { templates } : {})
          };
        } catch {
          return item;
        }
      })
    );
    // ✅ set 1 lần
    setInfoCampaign?.({
      ...infoCampaign,
      channelList: nextData
    });
  };

  const formatJSXChanelList = () => {
    return (
      <>
        {
          infoCampaign?.channelList?.map((item, i) =>
            <div
              key={i}
              className="custom-page-css w-full flex gap-2">
              <div className="custom-page-css flex flex-1 ">
                <div className="custome-page-css flex items-center gap-1 w-fit">
                  <img
                    src={channels[item.channelId - 1].icon} alt=""
                    onError={(e) => {
                      e.currentTarget.src = ZNS;
                    }}
                  />
                  <span className='custom-page-css text-344054 text-xs font-regular'>{channels[item.channelId - 1].title}</span>
                </div>
              </div>
              <div className="custom-page-css flex flex-2 items-center text-344054 text-sm font-medium">
                {getTitleSelectOption(item.brands ?? [], item.brandId ?? 0)}
              </div>
              <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-medium">
                {getTitleSelectOption(item.templates ?? [], item.notificationTemplateId ?? 0)}
              </div>
              <div className="custom-page-css flex flex-2 items-center text-344054 text-sm font-medium">
                {item.categories}
              </div>
              <div className="custom-page-css flex flex-1 items-center text-344054 text-sm font-medium">
                {formatNumber(item.status?.success ?? 0)}
              </div>
              <div className="custom-page-css flex flex-1 items-center text-344054 text-sm font-medium">
                {formatNumber(item.status?.failed ?? 0)}
              </div>

            </div>
          )
        }

      </>
    )
  }

  useEffect(() => {
    if (infoCampaign?.channelList?.length) {

      if (step === CampaignStep.PREVIEW)
        gInfoCampaignCosts(infoCampaign?.channelList)

      const hasValidChannel = infoCampaign?.channelList.some(channel =>
        (channel.brandId && channel.brands?.length > 0) ||
        (channel.notificationTemplateId && channel.templates?.length > 0)
      );

      if (!hasValidChannel && !channelDataFetchedRef.current) {
        channelDataFetchedRef.current = true
        gDatachannelList(infoCampaign.channelList)
      }
    } else {
      setInfoCampaignCosts(undefined)
    }
  }, [infoCampaign, sqlTotal, selectedIdCustomer])

  return (
    <div className='custom-page-css w-full  flex flex-col gap-4 pt-4'>
      {
        location.state.action === 'access' &&
        <div className="custom-page-css  w-full flex  gap-3">
          <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mã chiến dịch</span>

          <span className="custom-page-css flex items-center gap-3 flex-5 font-bold text-base">

            <Switch
              className="rs-switch rs-switch--sm"
              checked={location.state.view ? true : false}
            // onChange={() => onChangeActive(id)}
            />
            {infoCampaign?.code}
          </span>
        </div>
      }
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Tên chiến dịch thủ công</span>
        <span className="custom-page-css flex-5 font-bold text-base">{infoCampaign?.title}</span>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mô tả</span>
        <span className="custom-page-css flex-5 font-medium text-base">{infoCampaign?.description}</span>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mục tiêu</span>

        <div className="custom-page-css flex-5 font-bold text-base">
          <div className="custome-page-css flex gap-2 w-fit">
            {
              dataTarget.map((item, i) => (
                <Radio.Button
                  key={i}
                  value={infoCampaign?.targetId}
                  className={`custom-page-css flex items-center gap-4 rounded `}
                  // style={{
                  //   border: `1px solid #${item?.colorBorder?.trim()}!important`
                  // }}
                   style={{
                      borderColor: `#${item?.colorBorder.trim()}`,
                      color: `#${item?.colorText.trim()}`,
                      backgroundColor: `#${item?.bgColor.trim()}`, // 1A = 10% opacity
                    }}
                >
                  <SvgIconWithMask
                    src={URL_TEMPLATE_IMG + item?.icon}
                    onError={<TagOutlined />}
                    color={`#${item?.colorText}`}
                    size={18}
                  />
                  <span className=''>{item?.title}</span>
                </Radio.Button>
              ))
            }
          </div>
        </div>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Hình thức</span>
        <div className="custom-page-css flex-5 font-bold text-base">
          {infoCampaign?.type === SendStrategy.PRIORITY_BY_CHANNEL ? 'Ưu tiên gửi theo kênh' : 'Đồng thời gửi nhiều kênh'}
        </div>

      </div>
      <div className="custom-page-css  w-full flex  gap-3">
        <div className="custom-page-css flex gap-2 items-center flex-1 ">
          <img src={user_double} alt="" />
          <span className='custom-page-css text-base font-regular'>Số lượng khách hàng</span>
          <span className='custom-page-css text-base font-regular'>{formatPrice(selectedIdCustomer.length)}</span>
        </div>
        <div className="custom-page-css flex gap-2 items-center flex-1 ">
          <CalendarOutlined />
          <span className='custom-page-css text-base font-regular'>Thời gian gửi</span>
          <span className='custom-page-css text-base font-regular'>
            {(() => {
              switch (infoCampaign?.role) {
                case SendTimeType.NOW:
                  return 'Tức thì'
                case SendTimeType.SCHEDULED:
                  return `Lên lịch ${formatDateToDMYGroup(infoCampaign?.dateSend)} - ${infoCampaign?.timeSend}`
                case SendTimeType.OPTIONS:
                  return `Gửi trước ${getTitleSelectOption(dataSendEvent, infoCampaign?.sendEvent ?? 0)} ${infoCampaign?.sendInAdvance} ${infoCampaign?.sendBeforeUnit ?? "day" === 'day' ? 'ngày' : 'giờ'} lúc ${infoCampaign?.sendHour ?? infoCampaign?.timeSend}`
                default:
                  return ''
              }
            })()}
          </span>
        </div>

      </div>
      <div className="custom-page-css  w-full flex flex-col  gap-2">
        <span className="custom-page-css flex-2 text-344054 font-medium text-base">Mẫu nội dung cho kênh gửi</span>
        <div className="custom-page-css w-full flex flex-col gap-3">
          <div className="custom-page-css w-full flex gap-2">
            <div className="custom-page-css flex flex-1 items-center text-344054 text-sm font-regular">
              Kênh gửi
            </div>
            <div className="custom-page-css flex flex-2 items-center text-344054 text-sm font-regular">
              Brandname
            </div>
            <div className="custom-page-css flex flex-3 items-center text-344054 text-sm font-regular">
              Mẫu nội dung
            </div>
            <div className="custom-page-css flex flex-2 items-center text-344054 text-sm font-regular">
              Thương hiệu hãng xe
            </div>
            <div className="custom-page-css flex flex-1 items-center text-344054 text-sm font-regular">
              Gửi thành công
            </div>
            <div className="custom-page-css flex flex-1 items-center text-344054 text-sm font-regular">
              Gửi thất bại
            </div>

          </div>
          {formatJSXChanelList()}

        </div>

      </div>

      {/* //#region xét điều kiện hay nhóm */}
      {
        dataCondition ?
          <>
            <div className="custom-page-css flex flex-col gap-2 flex-1">
              <span
                className='custom-page-css text-base font-bold'>
                Điều kiện lọc
                <span className='custom-page-css text-base text-1890FF font-medium'>
                  {
                    dataCondition.typeCondition !== CONDITIONGROUP.ALL ?
                      (dataCondition.conditions.length > 0 ?
                        `(${dataCondition.conditions.length} tiêu chí đang áp dụng)` :
                        '') :
                      '(1 tiêu chí đang áp dụng)'
                  }
                </span>
              </span>
              {
                dataCondition?.conditions.length > 0 && <>
                  <div className="custom-page-css flex gap-2 flex-1">
                    <div className="custom-page-css flex flex-col gap-2 flex-1">
                      <span className='custom-page-css text-base text-344054 font-regular'>Trường</span>

                    </div>
                    <div className="custom-page-css flex flex-col gap-2 flex-1">
                      <span className='custom-page-css text-base text-344054 font-regular'>Điều kiện</span>
                    </div>
                    <div className="custom-page-css flex flex-col gap-2 flex-1">
                      <span className='custom-page-css text-base text-344054 font-regular'>Giá trị</span>
                    </div>
                  </div>
                  <div className="custom-page-css flex flex-col flex-1">
                    {
                      dataCondition?.conditions?.map((item, i) => (
                        <div
                          key={i}
                          className="custom-page-css flex gap-2 flex-1"
                        >
                          <div className="custom-page-css flex flex-col gap-2 flex-1">
                            <span className='custom-page-css text-base text-344054 font-medium'>
                              {item?.CustomerField?.label}
                            </span>
                          </div>
                          <div className="custom-page-css flex flex-col gap-2 flex-1">
                            <span className='custom-page-css text-base text-344054 font-medium'>
                              {item?.condition?.label}
                            </span>
                          </div>
                          <div className="custom-page-css flex gap-2 flex-1">
                            <ItemConditionDisplay
                              item={item}
                            />
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </>
              }
            </div>
          </> :
          <div className="custom-page-css  w-full flex flex-col  gap-3">
            <span className="custom-page-css  text-344054 font-bold text-base">
              Danh sách nhóm khách hàng ({infoCampaign?.groupCustomerId?.length ?? 0})
            </span>
            <div className="custom-page-css flex items-center gap-2">
              {
                infoCampaign?.groupCustomerId?.map((item, i) => (
                  <span
                    key={i}
                    className='custom-page-css uppercase text-344054 font-regular text-xs bg-F9FAFB p-1 rounded'>
                    {item.title} ({formatNumber(item.total ?? 0)})
                  </span>
                ))
              }
            </div>
          </div>
      }
      {/* //#endregion */}
      <Tabs
        defaultActiveKey="1"
        items={items}
      />

      <div className="custom-page-css  w-full flex flex-col  gap-3">
        <span className="custom-page-css  text-344054 font-bold text-base">Dự tính chi phí</span>
        <div className="custom-page-css flex  gap-2">
          <div className="custom-page-css px-2 py-1 bg-E6F7FF rounded w-fit h-fit"
            onClick={() => setMore(!isMore)}
          >
            {
              isMore ?
                <LineOutlined style={{ color: '#1890FF' }} /> :
                <PlusOutlined style={{ color: '#1890FF' }} />
            }
          </div>
          <div className="custom-page-css flex flex-1 flex-col gap-2 pt-1">
            {
              infoCampaignCosts?.Email && infoCampaignCosts?.Email?.length > 0 && (
                <div className={`custom-page-css flex flex-1 flex-col gap-2 ${isMore ? '' : 'd-none'} `}>
                  <div className="custom-page-css flex flex-1 items-center justify-between">
                    <span className='custom-page-css  text-344054 font-medium text-sm'>EMAIL</span>
                    <span className='custom-page-css text-344054 text-sm'>{formatPrice(infoCampaignCosts?.totalEmailExpense)}đ</span>
                  </div>
                  {
                    infoCampaignCosts?.Email.map((item, i) => (
                      <div key={i} className="custom-page-css w-full flex items-center justify-between ">
                        <div className="custom-page-css flex items-center gap-2">
                          <div className="custom-page-css flex items-center justify-center p-2 border rounded border-EAECF0 w-16 h-6">
                            <img
                              src={URL_NETWORK + item.networkImage} alt=""
                              onError={(e) => {
                                e.currentTarget.src = viettel;
                              }} />
                          </div>
                          <span>{item.networkTitle}</span>
                        </div>
                        <span className='custom-page-css text-667085 text-xs'>{formatPrice(item.expense)}đ</span>
                      </div>
                    ))
                  }

                </div>
              )
            }
            {
              infoCampaignCosts?.ZNS && infoCampaignCosts?.ZNS?.length > 0 && (
                <div className={`custom-page-css flex flex-1 flex-col gap-2 ${isMore ? '' : 'd-none'} `}>
                  <div className="custom-page-css flex flex-1 items-center justify-between">
                    <span className='custom-page-css  text-344054 font-medium text-sm'>ZNS</span>
                    <span className='custom-page-css text-344054 text-sm'>{formatPrice(infoCampaignCosts?.totalZNSExpense)}đ</span>
                  </div>
                  {
                    infoCampaignCosts?.ZNS.map((item, i) => (
                      <div key={i} className="custom-page-css w-full flex items-center justify-between ">
                        <div className="custom-page-css flex items-center gap-2">
                          <div className="custom-page-css flex items-center justify-center p-2 border rounded border-EAECF0 w-16 h-6">
                            <img
                              src={URL_NETWORK + item.networkImage} alt=""
                              onError={(e) => {
                                e.currentTarget.src = viettel;
                              }} />
                          </div>
                          <span>{item.networkTitle}</span>
                        </div>
                        <span className='custom-page-css text-667085 text-xs'>{formatPrice(item.expense)}đ</span>
                      </div>
                    ))
                  }

                </div>
              )}
            {
              infoCampaignCosts?.SMS.length && (
                <div className={`custom-page-css flex flex-1 flex-col gap-2 ${isMore ? '' : 'd-none'} `}>
                  <div className="custom-page-css flex flex-1 items-center justify-between">
                    <span className='custom-page-css  text-344054 font-medium text-sm'>SMS</span>
                    <span className='custom-page-css text-344054 text-sm'>{formatPrice(infoCampaignCosts?.totalSMSExpense)}đ</span>
                  </div>
                  {
                    infoCampaignCosts?.SMS.map((item, i) => (
                      <div key={i} className="custom-page-css w-full flex items-center justify-between ">
                        <div className="custom-page-css flex items-center gap-2">
                          <div className="custom-page-css flex items-center justify-center p-2 border rounded border-EAECF0 w-16 h-6">
                            <img
                              src={URL_NETWORK + item.networkImage} alt=""
                              onError={(e) => {
                                e.currentTarget.src = viettel;
                              }} />
                          </div>
                          <span>{item.networkTitle}</span>
                        </div>
                        <span className='custom-page-css text-667085 text-xs'>{formatPrice(item.expense)}đ</span>
                      </div>
                    ))
                  }

                </div>
              )
            }

            <div className="custom-page-css flex flex-1 items-center justify-between">
              <span className='custom-page-css  text-344054 font-medium text-sm'>Tạm tính</span>
              <div className="custom-page-css flex items-center gap-3 text-039855 font-bold text-base">
                <span>{formatPrice(infoCampaignCosts?.totalChannelExpense)}đ</span>
                <span>~</span>
                <span>{formatPrice(infoCampaignCosts?.totalChannelExpense)}đ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(Detail)
